"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyOfRenderer = void 0;
exports.AnyOfControl = AnyOfControl;
const jsx_runtime_1 = require("react/jsx-runtime");
/*
AnyOfControl should be used when a form item would control other elements within the same form
AnyOfRenderer does not have options to render the label as a title
*/
const core_1 = require("@jsonforms/core");
const react_1 = require("@jsonforms/react");
const antd_1 = require("antd");
const react_2 = require("react");
const CombinatorSchemaSwitcher_1 = require("./CombinatorSchemaSwitcher");
function AnyOfControl({ handleChange, data, schema, path, renderers, cells, rootSchema, indexOfFittingSchema, uischema, uischemas, config, required, }) {
    const [selectedIndex, setSelectedIndex] = (0, react_2.useState)(indexOfFittingSchema ?? 0);
    const combinatorRenderInfos = (0, core_1.createCombinatorRenderInfos)(schema.anyOf, rootSchema, "anyOf", uischema, path, uischemas);
    const [renderCount, setRenderCount] = (0, react_2.useState)(1);
    (0, react_2.useEffect)(() => {
        // this is a janky workaround for two problems
        // 1) we need a more mature method of handling default value creation (possibly via middleware)
        //    bc doing it in the view layer isn't ideal
        // 2) there's some kind of bug in @jsonforms/react that causes the first call to
        //    handleChange to be ignored: https://jsonforms.discourse.group/t/updating-on-custom-renderer-load/1984
        //    need to file a MRE and add it here
        if (data === undefined && renderCount === 2) {
            setRenderCount(3);
            const newSchema = combinatorRenderInfos[selectedIndex]?.schema;
            if (!newSchema) {
                handleChange(path, {});
            }
            else {
                const newData = (0, core_1.createDefaultValue)(newSchema, rootSchema);
                handleChange(path, newData);
            }
        }
        if (renderCount === 1) {
            setRenderCount(2);
        }
    }, [
        data,
        renderCount,
        combinatorRenderInfos,
        selectedIndex,
        handleChange,
        path,
        rootSchema,
    ]);
    const labelDescription = core_1.Helpers.createLabelDescriptionFrom(uischema, schema);
    const formItemProps = "formItemProps" in uischema ? uischema.formItemProps : {};
    return ((0, jsx_runtime_1.jsxs)(antd_1.Space, { direction: "vertical", style: { width: "100%" }, size: "middle", children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, { rules: [{ required, message: `${schema.title} is required` }], label: labelDescription.show ? labelDescription.text : "", ...formItemProps, children: (0, jsx_runtime_1.jsx)(CombinatorSchemaSwitcher_1.CombinatorSchemaSwitcher, { config: config, renderInfos: combinatorRenderInfos, selectedIndex: selectedIndex, setSelectedIndex: setSelectedIndex, uischema: uischema, path: path, 
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    data: data, handleChange: handleChange, rootSchema: rootSchema }) }), combinatorRenderInfos.map((renderInfo, index) => {
                return (selectedIndex === index && ((0, jsx_runtime_1.jsx)(react_1.JsonFormsDispatch, { schema: renderInfo.schema, uischemas: uischemas, uischema: renderInfo.uischema, path: path, renderers: renderers, cells: cells }, index)));
            })] }));
}
exports.AnyOfRenderer = (0, react_1.withJsonFormsOneOfProps)(AnyOfControl);
